module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"success":"Успешно!","copy-success":"Ссылка на веб-версию скопирована"},"en":{"success":"Success!","copy-success":"Link to web version is successfully copied"}}')
  delete Component.options._Ctor
}
